const Globals = {
    logo: window.logo,
    logoWidth: window.logoWidth,
    layout: window.layout,
    website: window.website,
    defaultColor: window.initial_misc_color,
    defaultFont: window.initial_misc_font,
    colors: window.emailSignatureColors,
    fonts: window.emailSignatureFonts,
    textFieldDefaults: {
        name: {
            value: 'Sample Name',
            color: window.initial_name_color,
            label: '',
            font: window.initial_name_font,
        },
        jobTitle: {
            value: 'Position',
            color: window.initial_job_title_color,
            label: '',
            font: window.initial_job_title_font,
        },
        email: {
            value: '',
            color: window.initial_email_color,
            label: '',
            font: window.initial_email_font,
        },
        pronouns: {
            value: '',
            color: window.initial_pronouns_color,
            label: '',
            font: window.initial_pronouns_font,
        },
        company: {
            value: '',
            color: window.initial_company_color,
            label: '',
            font: window.initial_company_font,
        },
        website: {
            value: '',
            color: window.initial_website_color,
            label: '',
            font: window.initial_website_font,
            url: '',
        },
        address: {
            value: '',
            color: window.initial_address_color,
            label: '',
            font: window.initial_address_font,
        },
        bottom: {
            value: '<p class="ask">Ask us about our services</p><p class="links"><a href="https://altamoving.ca/">Moving</a>   |   <a href="https://altastorage.ca/">Storage</a>   |    <a href="https://altastorage.ca/frogbox/">Frogbox</a>   |    <a href="https://altastorage.ca/portable-storage">Rental Equipment</a>   </p>',
            color: window.initial_bottom_color,
            label: '',
            font: window.initial_bottom_font,
        },
    },
}

export default Globals
